module.exports = __webpack_public_path__ + "media/images/products/demo/slideri2-7fed8f65ab780cae510719afb96e4968.jpg";